import { useLoading } from '@genial/components';
import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { useSetRecoilState } from 'recoil';

import { useToastCreator } from '../../hooks/useToastCreator';
import { postTfaCodeService } from '../../pages/BatchTicketInvestLink/services/authenticationService';
import {
  cancelCustomerOffer,
  patchCustomerOffer,
} from '../../pages/BatchTicketInvestLink/services/BatchTicketInvestLinkService';
import {
  PostTfaToken,
  TfaCodeProps,
  PatchBasketCustomerOffers,
  RefuseBasketCustomerOffer,
} from '../../pages/BatchTicketInvestLink/utils/types';
import { errorMessageBatchTicketRequestItem } from '../../pages/BatchTicketRequests/utils';

import { authorizationTokenState, customerOrderIdState } from './atom';

export const useBatchTicketInvestLinkActions = () => {
  const setCustomerOrderId = useSetRecoilState(customerOrderIdState);
  const setAuthorizationToken = useSetRecoilState(authorizationTokenState);

  const { hide, show } = useLoading();

  const { showToast, showToastFromError } = useToastCreator(
    'toast-batch-ticket-invest-link-actions'
  );

  const addCustomerOrderId = (customerOrderId: string) => {
    setCustomerOrderId(customerOrderId);
  };

  const postTfaCode = async ({ tfaCode, basketCustomerId }: PostTfaToken) => {
    try {
      const data = await postTfaCodeService(basketCustomerId, tfaCode);

      if (data) {
        setAuthorizationToken(data.tfaToken as TfaCodeProps);
      }

      return data.tfaToken as unknown as TfaCodeProps;
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        throw error;
      }
      showToast(...errorMessageBatchTicketRequestItem);
      throw error;
    }
  };

  const patchCustomerOffers = async ({
    basketCustomerOrderId,
    customerOffers,
    jwtToken,
  }: PatchBasketCustomerOffers) => {
    try {
      show({ title: '', description: '' });
      await patchCustomerOffer({
        basketCustomerOrderId,
        customerOffers,
        jwtToken,
      });
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        throw error;
      }
      showToast(...errorMessageBatchTicketRequestItem);
      throw error;
    } finally {
      hide();
    }
  };

  const refuseCustomerOffer = async ({
    basketCustomerOrderId,
    jwtToken,
  }: RefuseBasketCustomerOffer) => {
    try {
      show({ title: '', description: '' });
      await cancelCustomerOffer({
        basketCustomerOrderId,
        jwtToken,
      });
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        throw error;
      }
      showToast(...errorMessageBatchTicketRequestItem);
      throw error;
    } finally {
      hide();
    }
  };

  return {
    addCustomerOrderId,
    postTfaCode,
    patchCustomerOffers,
    refuseCustomerOffer,
  };
};
